import Vue from 'vue'
import VueResource from 'vue-resource'
import config from '../config'// 配置
import utils from '@/js/utils'
import router from '../router'
import store from '@/js/store/store'
import cookieTools from '../js/cookie'
import md5 from 'js-md5';
let env = process.env.NODE_ENV
Vue.use(VueResource)

Vue.http.options.root = config[env].httpRoot
// Vue.http.headers.common['Access-Control-Allow-Origin'] = 'http://localhost:8083'
// Vue.http.headers.common['Access-Control-Allow-Headers'] = 'Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With'
// Vue.http.headers.common['Access-Control-Allow-Methods'] = 'GET,POST,PUT,DELETE,OPTIONS'
// Vue.http.headers.common['Content-Type'] = 'application/json; charset=UTF-8'
// Vue.http.headers.common['appClientInfo'] = '{"clientId":"1"}'


export default {
  post: function (url, data, successCallback, errCallback = function () {}, isShowErrMsg = true) {
    post(url, data, successCallback, errCallback, isShowErrMsg)
  },
  get: function (url, data, successCallback, errCallback = function () {}, isShowErrMsg = true) {
    get(url, data, successCallback, errCallback, isShowErrMsg)
  }
}

// get函数，直接调用vue.http进行请求
function get (url, data, successCallback, errCallback, isShowErrMsg) {
  if (localStorage.getItem('user-token-cache') !== null && localStorage.getItem('user-token-cache').length > 0) {
    // Vue.http.headers.common['authorization'] = store.state.user.token
    Vue.http.headers.common['authorization'] = localStorage.getItem('user-token-cache')

  }
  if (localStorage.getItem('loginCredentials') !== null && localStorage.getItem('loginCredentials').length > 0) {
    Vue.http.headers.common['loginCredentials'] = localStorage.getItem('loginCredentials')
  }
  if (localStorage.getItem('cacheKey') !== null && localStorage.getItem('cacheKey').length > 0) {
    Vue.http.headers.common['cacheKey'] = localStorage.getItem('cacheKey')
  }

  // Vue.http.headers.common['authorization'] = store.state.user.token
  // Vue.http.headers.common['loginCredentials'] = localStorage.getItem('loginCredentials')
  // Vue.http.headers.common['cacheKey'] = localStorage.getItem('cacheKey')
  Vue.http.get(url, {params:data}).then(function (respond) {
    dealSuccess(url, data, successCallback, errCallback, isShowErrMsg, respond, 'GET')
  }, function (errRsp) {

    dealErr(url, data, successCallback, errCallback, isShowErrMsg, errRsp)
  })
}

// post函数，直接调用vue.http进行请求
function post (url, data, successCallback, errCallback, isShowErrMsg) {
  if (localStorage.getItem('user-token-cache') !== null && localStorage.getItem('user-token-cache').length > 0) {
    Vue.http.headers.common['authorization'] = localStorage.getItem('user-token-cache')
  }
  if (localStorage.getItem('loginCredentials') !== null && localStorage.getItem('loginCredentials').length > 0) {
    Vue.http.headers.common['loginCredentials'] = localStorage.getItem('loginCredentials')
  }
  if (localStorage.getItem('cacheKey') !== null && localStorage.getItem('cacheKey').length > 0) {
    Vue.http.headers.common['cacheKey'] = localStorage.getItem('cacheKey')
  }

  Vue.http.post(url, data).then(function (respond) {
    dealSuccess(url, data, successCallback, errCallback, isShowErrMsg, respond, 'POST')
  }, function (errRsp) {
    dealErr(url, data, successCallback, errCallback, isShowErrMsg, errRsp)
  })
}

// 处理vue.http返回successRespond
function dealSuccess (url, data, successCallback, errCallback, isShowErrMsg, respond, method) {
  console.log(respond)
  if (parseInt(respond['body']['meta']['code']) === 0) {
    successCallback(respond)

  } else if (parseInt(respond['body']['meta']['code']) === 12029) {
     router.push('/chooseCity')

  } else if (parseInt(respond['body']['meta']['code']) === 12037) {
    localStorage.setItem('userIsLogin', false)
    localStorage.setItem('isWxLogin-cache', false)
    store.dispatch('setLogin',false)
    dealFailure(respond, errCallback, isShowErrMsg)
    router.push('/loginEntrance')

  } else if (parseInt(respond['body']['meta']['code']) === 12005 || parseInt(respond['body']['meta']['code']) === 12009) {
    // 当后台返回token过期错误时，进行特殊处理
    console.log('token error')
    dealTokenErr(url, data, successCallback, errCallback, isShowErrMsg, method)
  } else if (parseInt(respond['body']['meta']['code']) === -1) {
    var errRsp = {}
    errRsp.status = -1

    dealErr(url, data, successCallback, errCallback, isShowErrMsg,errRsp)
  } else {
    dealFailure(respond, errCallback, isShowErrMsg)

  }
}

// 处理vue.http返回errorRespond
function dealErr (url, data, successCallback, errCallback, isShowErrMsg, errRsp) {
  let rsp = {}
  rsp.body = {}
  rsp.body = {
    meta: {
      code: errRsp.status,
      msg: '服务器开小差 ' + '(code: ' + errRsp.status + ' )'
    }
  }
  // rsp.body.code = errRsp.status
  // rsp.body.msg = '服务器开小差 ' + '(code: ' + errRsp.status + ' )'
  dealFailure(rsp, errCallback, isShowErrMsg)

}

// 当后台返回tokenError错误的时候，进行特殊处理。
function dealTokenErr (url, data, successCallback, errCallback, isShowErrMsg, method) {
  // 首先刷新token
  console.log('token错误进来了')
  refreshToken(function (res) {
    // 当刷新token成功，则重新请求接口
    console.log('刷新成功')

    console.log(url)
    if (res.success) {
      if (method === 'POST') {
        post(url, data, successCallback, errCallback, isShowErrMsg)
      } else if (method === 'GET') {
        get(url, data, successCallback, errCallback, isShowErrMsg)
      }
    } else { // 当刷新token失败，则进行别的处理
      // 暂定
    }
  })
}

// 刷新token
function refreshToken (callback) {
  // let url = 'api/common/refreshToken'
  let url = 'api/common/refreshToken'

  // 当没有获取过token得时候，用默认的账号获取一个token
  if (store.state.user.refreshToken === '') {
    getToken(callback)
  } else {
    Vue.http.get(url, {params: {refreshToken: localStorage.getItem('user-refreshtoken-cache')}}).then(function (respond) {
      let res = {}
      if (parseInt(respond.body.meta.code) === 0) {
        res.success = true
        // console.log('begin token', store.state.user.token)
        // store.dispatch('setRefreshToken', respond.body.data.refreshToken)
        // store.dispatch('setToken', respond.body.data.token)
        localStorage.setItem('user-refreshtoken-cache', respond.body.data.refreshToken)
        localStorage.setItem('user-token-cache', respond.body.data.token)
        console.log('end token', store.state.user.token)
        callback(res)
      } else {
        // console.log('token refresh err')
        // console.log(respond)
        getToken(callback)
      }
    }, function (errRsp) {
      let rsp = {}
      rsp.body = {}
      rsp.body.code = errRsp.status
      rsp.body.msg = errRsp.statusText + '(' + errRsp.status + ')'
      dealFailure(rsp, function () {}, true)
    })
  }

}

function dealFailure (err, errCallback, isShowErrMsg) {
  console.log(err)
  errCallback(err)
  if (isShowErrMsg) {
    if (err.body.hasOwnProperty('meta')) {
      utils.alert(err.body.meta.msg)
      // utils.alert('服务器开小差')
    }
    else {
      utils.alert(err.body.msg)
      // utils.alert('服务器开小差')
    }

  }
}

// 获取token，用于每次请求
function getToken(callback = function(){}, clientId = 'XF0002', clientSecret = 'blissmall') {
  var timestamp = Date.parse(new Date())
  var passwordMD5 = md5(clientSecret)
  var signStr = clientId + passwordMD5 + timestamp
  var signMD5 = md5(signStr)
  console.log(signMD5)

  var data = {}
  data.clientId = clientId
  data.clientSecret = passwordMD5
  data.timestamp = timestamp
  data.sign = signMD5

  var url = 'api/common/getToken'

  Vue.http.post(url, data).then(function (respond) {
    console.log(respond.body)
    let res = {}
    if (parseInt(respond.body.meta.code) === 0) {
      res.success = true
      localStorage.setItem('user-refreshtoken-cache', respond.body.data.refreshToken)
      localStorage.setItem('user-token-cache', respond.body.data.token)
      // store.dispatch('setRefreshToken', respond.body.data.refreshToken)
      // store.dispatch('setToken', respond.body.data.token)
      // console.log('get new token', store.state.user.token)
      callback(res)
    } else {
      res.success = false
      console.log(respond)
      callback(res)
    }
  }, function (errRsp) {
    console.log(errRsp.body)

  })
}



// WEBPACK FOOTER //
// ./src/api/api.js